import { render } from "./booklist.vue?vue&type=template&id=0d738e98&scoped=true"
import script from "./booklist.vue?vue&type=script&lang=js"
export * from "./booklist.vue?vue&type=script&lang=js"

import "./booklist.vue?vue&type=style&index=0&id=0d738e98&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d738e98"]])

export default __exports__